import React from 'react';
import { Box, Button, TextField } from '@mui/material';
import District from '../../model/District';
import Stage3JuryPairsList, { Stage3JuryPairItem } from './Stage3JuryPairsList';
import Stage3JuryPairForm, { Stage3JuryPairDraft } from './Stage3JuryPairForm';

type Props = {
	districts: District[];
	draft: Stage3JuryPairDraft;
	onDraftChange: (draft: Stage3JuryPairDraft) => void;
	onDraftReset: () => void;
	onSavePair: () => void;
	pairs: Stage3JuryPairItem[];
	onEditPair: (pair: Stage3JuryPairItem) => void;
	onDeletePair: (pair: Stage3JuryPairItem) => void;
	juryParentFolderUrl: string;
	setJuryParentFolderUrl: (value: string) => void;
	shareMessage: string;
	setShareMessage: (value: string) => void;
	testRecipientEmail: string;
	setTestRecipientEmail: (value: string) => void;
	sendNotificationEmail: boolean;
	overwriteExisting: boolean;
	onCreateJuryFolders: () => void;
	onVerifyJuryFolders: () => void;
	onShareJuryFolders: () => void;
	juryActionReport: any | null;
	juryVerifyStatusByPairId: Record<number, boolean>;
	juryVerifyErrorByPairId: Record<number, string>;
	busy: boolean;
};

const Stage3JuryPairsManagementTab = ({
	districts,
	draft,
	onDraftChange,
	onDraftReset,
	onSavePair,
	pairs,
	onEditPair,
	onDeletePair,
	juryParentFolderUrl,
	setJuryParentFolderUrl,
	shareMessage,
	setShareMessage,
	testRecipientEmail,
	setTestRecipientEmail,
	sendNotificationEmail,
	overwriteExisting,
	onCreateJuryFolders,
	onVerifyJuryFolders,
	onShareJuryFolders,
	juryActionReport,
	juryVerifyStatusByPairId,
	juryVerifyErrorByPairId,
	busy,
}: Props) => {
	const currentPairVerified = draft.id ? Boolean(juryVerifyStatusByPairId[Number(draft.id)]) : false;
	const currentPairVerifyError = draft.id ? String(juryVerifyErrorByPairId[Number(draft.id)] || '') : '';
	return (
		<>
			<Stage3JuryPairForm
				districts={districts}
				draft={draft}
				onChange={onDraftChange}
				onSave={onSavePair}
				onReset={onDraftReset}
				isSaving={busy}
				currentPairVerified={currentPairVerified}
				currentPairVerifyError={currentPairVerifyError}
			/>
			<Stage3JuryPairsList
				pairs={pairs}
				onEdit={onEditPair}
				onDelete={onDeletePair}
				juryVerifyStatusByPairId={juryVerifyStatusByPairId}
				juryVerifyErrorByPairId={juryVerifyErrorByPairId}
			/>
			<Box sx={{ mt: 2 }}>
				<TextField
					fullWidth
					size='small'
					label='Folder nadrzędny dla komisji'
					value={juryParentFolderUrl}
					onChange={(e) => setJuryParentFolderUrl(e.target.value)}
				/>
				<TextField
					fullWidth
					size='small'
					multiline
					minRows={2}
					label='Treść wiadomości udostępnienia (opcjonalnie)'
					value={shareMessage}
					onChange={(e) => setShareMessage(e.target.value)}
					sx={{ mt: 1 }}
				/>
				<TextField
					fullWidth
					size='small'
					label='Testowy e-mail override (opcjonalnie)'
					value={testRecipientEmail}
					onChange={(e) => setTestRecipientEmail(e.target.value)}
					sx={{ mt: 1 }}
					helperText='Jeśli ustawione, udostępnienia komisji trafią wyłącznie na ten adres.'
				/>
				<Box sx={{ mt: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
					<Button
						variant='outlined'
						onClick={onCreateJuryFolders}
						disabled={busy}
					>
						Tworzenie
					</Button>
					<Button
						variant='outlined'
						onClick={onVerifyJuryFolders}
						disabled={busy}
					>
						Weryfikacja
					</Button>
					<Button
						variant='contained'
						onClick={onShareJuryFolders}
						disabled={busy}
					>
						Udostępnianie
					</Button>
				</Box>
				{juryActionReport && (
					<Box sx={{ mt: 1 }}>
						<details>
							<summary>Raport działań dla komisji</summary>
							<TextField
								fullWidth
								multiline
								minRows={6}
								value={JSON.stringify(juryActionReport, null, 2)}
								InputProps={{ readOnly: true }}
								sx={{ mt: 1 }}
							/>
						</details>
					</Box>
				)}
			</Box>
		</>
	);
};

export default Stage3JuryPairsManagementTab;
